import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import useIPLocation from '@outdoor-voices/ui/dist/utils/hooks/useIPLocation';
import { DEFAULT_MESSAGE, UNKNOWN_REGION, QUERY, SHIPPING_DRAWER_LABEL } from './constants';
import css from './index.module.scss';
import Overlay from '../../../components/Ovly';
import Spinner from '../../../components/icons/Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Shipping = function Shipping(_ref) {
  var padded = _ref.padded;

  var _useState = useState(DEFAULT_MESSAGE),
      _useState2 = _slicedToArray(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var _useState3 = useState(UNKNOWN_REGION),
      _useState4 = _slicedToArray(_useState3, 2),
      region = _useState4[0],
      setRegion = _useState4[1];

  var _useIPLocation = useIPLocation(),
      _useIPLocation2 = _slicedToArray(_useIPLocation, 2),
      ipFetching = _useIPLocation2[0],
      ipData = _useIPLocation2[1];

  var _useQuery = useQuery({
    query: QUERY,
    variables: {
      region: region
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      regionFetching = _useQuery2$.fetching,
      regionData = _useQuery2$.data;

  var isFetching = ipFetching || regionFetching;
  useEffect(function () {
    var _ipData$countryCode;

    var ipDataRegion = (_ipData$countryCode = ipData === null || ipData === void 0 ? void 0 : ipData.countryCode) !== null && _ipData$countryCode !== void 0 ? _ipData$countryCode : UNKNOWN_REGION;
    var updatedRegion = ipDataRegion === 'undefined' ? UNKNOWN_REGION : ipDataRegion;
    setRegion(updatedRegion);
  }, [ipData]);
  useEffect(function () {
    var _regionData$regions$e, _regionData$regions, _regionData$regions$e2, _regionData$regions$e3;

    var updatedMessage = (_regionData$regions$e = regionData === null || regionData === void 0 ? void 0 : (_regionData$regions = regionData.regions) === null || _regionData$regions === void 0 ? void 0 : (_regionData$regions$e2 = _regionData$regions.edges[0]) === null || _regionData$regions$e2 === void 0 ? void 0 : (_regionData$regions$e3 = _regionData$regions$e2.node) === null || _regionData$regions$e3 === void 0 ? void 0 : _regionData$regions$e3.pdpShippingMessage) !== null && _regionData$regions$e !== void 0 ? _regionData$regions$e : DEFAULT_MESSAGE;
    setMessage(updatedMessage);
  }, [regionData]);

  var button = /*#__PURE__*/_jsx("div", {
    className: css.button,
    children: SHIPPING_DRAWER_LABEL
  });

  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.padded, padded)]),
    children: /*#__PURE__*/_jsx(Overlay, {
      button: button,
      label: "".concat(SHIPPING_DRAWER_LABEL, " Information"),
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: css.title,
          children: SHIPPING_DRAWER_LABEL
        }), isFetching ? /*#__PURE__*/_jsx(Spinner, {}) : /*#__PURE__*/_jsx("div", {
          className: css.copy,
          dangerouslySetInnerHTML: {
            __html: message
          }
        })]
      })
    })
  });
};

Shipping.propTypes = {
  padded: PropTypes.bool
};
export default Shipping;